// hooks/useAuthInit.js
import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { logout, setTokensFromStorage } from "../redux/slice/authSlice";

const apiurl = "https://api.stockastix.com";

export const useAuthInit = () => {
  const dispatch = useDispatch();
  const location = useLocation(); 
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // 🟡 Add loading state

  useEffect(() => {
    const refreshToken = localStorage.getItem("refresh_token");

    const tryRefresh = async () => {
      if (!refreshToken) {
        dispatch(logout());
        setLoading(false);
        return;
      }

      try {
        const res = await axios.post(`${apiurl}/users/refresh_token/`, {
          refresh_token: refreshToken,
        });

        const { access_token, refresh_token: newToken } = res.data;

        dispatch(setTokensFromStorage({ accessToken: access_token }));
        localStorage.setItem("refresh_token", newToken);
        if (["/login", "/signup", "/"].includes(location.pathname)) {
          navigate("/discover");
        } 
      } catch (err) {
        localStorage.removeItem("refresh_token");
        dispatch(logout());
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    tryRefresh();
  }, [dispatch, navigate, location]);

  return { loading };
};
